import * as React from 'react';

import * as styles from './IconOk.css';

export const IconOk: React.FC = () => <div className={styles['ok-icon']} />;

IconOk.displayName = 'IconOk';
